<template>
  <div>
    <!-- Top -->
    <div class="mb-4 p-6 pb-0">
      <span
        v-if="modalTitle"
        data-modal-title
        class="text-xl font-medium"
        :class="{ 'flex items-center gap-2': $slots.titleBadge }">
        <slot name="titleBadge" />
        {{ modalTitle }}
      </span>
      <span
        v-if="modalIntro"
        class="text-text-primary">
        {{ modalIntro }}
      </span>
    </div>

    <!-- Content -->
    <div :class="contentClasses">
      <slot />
    </div>

    <!-- Buttons -->
    <div
      class="flex justify-end gap-2 px-6 pb-6"
      v-if="$slots.buttons">
      <slot name="buttons" />
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

export default {
  name: 'BaseModal',
  props: {
    modalTitle: {
      type: String,
      required: false,
    },
    modalIntro: {
      type: String,
      required: false,
    },
    contentPadding: {
      type: String as PropType<'none' | 'default'>,
      required: false,
      default: 'default',
    },
  },
  computed: {
    contentClasses(): { [key: string]: boolean } {
      return {
        'p-0': this.contentPadding === 'none',
        'px-6 pb-6': this.contentPadding === 'default',
      }
    },
  },
}
</script>

